import axios from "axios";
import { deviceStatusLookupSlice } from "../../slice/stations/getDeviceStatusLookupSlice";
import apiHeader from "../../../Components/ApiHeader";

const { actions } = deviceStatusLookupSlice;

export const deviceStatusDropdownAPI: any =
  ({ ApiUrl, Type, params }: any) =>
  (dispatch: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    axios
      .get(ApiUrl, {
        params: params,
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
      })
      .then((response) => {
        const { data } = response;
        dispatch(actions.getDeviceStatusData({ type: Type, data }));
      })
      .catch((err) => {
        dispatch(
          actions.getDeviceStatusData({ type: "error", paylod: err.message })
        );
      });
  };
